var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8234 11.0883V9.91174H1.17651V11.0883H8.23511V14.6176H17.6468V15.7942H8.23511V19.3235H1.17651V20.5H18.8234V19.3235H20V15.7942H18.8234V14.6176H20V11.0883H18.8234ZM17.6468 18.1469H16.4707V16.9707H17.6468V18.1469ZM17.6468 13.441H16.4707V12.2649H17.6468V13.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70581 16.9707H5.88237V18.1469H4.70581V16.9707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35303 16.9707H3.5292V18.1469H2.35303V16.9707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7941H1.17656V19.3234H0V15.7941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17651 14.6176H8.23511V15.7941H1.17651V14.6176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0883H1.17656V14.6176H0V11.0883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70581 12.2648H5.88237V13.441H4.70581V12.2648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35303 12.2648H3.5292V13.441H2.35303V12.2648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1175 4.0293V5.20586H12.9409V6.38242H11.7647V7.55899H10.5882V8.73516H9.41162V7.55899H8.23506V6.38242H7.05889V5.20586H5.88232V4.0293H8.23506V0.5H11.7647V4.0293H14.1175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.0f13c3976c15ed52cfed4a1ff71af2e7.svg";
export { ForwardRef as ReactComponent };